export const actionLabels = {
  ACCOUNT_ADD: "Account Added",
  ACCOUNT_REMOVE: "Account Removed",
  ACCOUNT_UPDATE: "Account Updated",
  PROFILE_PICTURE_UPDATE: "Updated Profile Picture",
  PROFILE_UPDATE: "Updated Profile",
  MISSED_TRACKING_SETTING_UPDATE: "Updated Missed Tracking Setting",
  MESSAGE_SETTING_UPDATE: "Updated Message Setting",
  MEAL_PLANNER_SETTING_UPDATE: "Updated Meal Planner Setting",
  CAMPAIGN_CREATE: "Campaign Created",
  CAMPAIGN_UPDATE: "Campaign Updated",
  CAMPAIGN_DELETE: "Campaign Deleted",
  GROUP_CREATE: "Group Created",
  GROUP_UPDATE: "Group Updated",
  GROUP_DELETE: "Group Deleted",
  GROUP_ASSIGN: "Group Assign",
  GROUP_REMOVE: "Group Remove",
  GROUP_BULK_REMOVE: "Group Bulk Remove",
  TRAINER_ASSIGN: "Trainer Assigned",
  TRAINER_REMOVE: "Trainer Removed",
  TRAINER_BULK_REMOVE: "Trainer Bulk Remove",
  FORM_CREATE: "Form Created",
  FORM_UPDATE: "Form Updated",
  FORM_DELETE: "Form Deleted",
  FORM_ASSIGN: "Form Assigned",
  FORM_UNASSIGN: "Form Unassigned",
  FORM_BULK_UNASSIGN: "Form Bulk Unassign",
  FORM_SCHEDULE_CREATE: "Scheduled Form Assignment Created",
  FORM_SCHEDULE_UPDATE: "Scheduled Form Assignment Updated",
  FORM_SCHEDULE_DELETE: "Scheduled Form Assignment Deleted",
  MEAL_TEMPLATE_CREATE: "Meal Template Created",
  MEAL_TEMPLATE_UPDATE: "Meal Template Updated",
  MEAL_TEMPLATE_DELETE: "Meal Template Deleted",
  DAY_TEMPLATE_CREATE: "Day Template Created",
  DAY_TEMPLATE_UPDATE: "Day Template Updated",
  DAY_TEMPLATE_DELETE: "Day Template Deleted",
  BULK_CHECKIN_DAY: "Bulk Check-in Day",
  BULK_VACATION_MODE: "Bulk Vacation Mode",
  GROUP_MESSAGE_SENT: "Send Group Message",
  GROUP_NOTIFICATION_SENT: "Send Group Notification",
  TEAM_MEMBER_ADD: "Team Member Added",
  TEAM_MEMBER_PERMISSION_UPDATE: "Team Member Permission Updated",
  TEAM_MEMBER_REMOVE: "Team Member Removed"
};

export const clientTargetTypes = {
  account: true,
  user: true
};

export const targetTypeLabels = {
  account: "Client",
  user: "Client",
  portal_user: "Portal User",
  group: "Group",
  form: "Form",
  trainer: "Trainer",
  meal_template: "Meal Template",
  day_template: "Day Template",
  campaign: "Campaign"
};

export const dayPickerModifiersStyles = {
  selected: {
    backgroundColor: "#1fc44a"
  }
};
